<template>
  <div :class="['framework-ratings',loading?'calculating-layout':'']">
    <a v-for="elementCode in selectedSchoolElementCodes"
      :key="elementCode"
      :href="'#'+elementCode"
      class="click-wrapper no-print-link"
      >
      <DivPrintableBackground :class="['rating-row',colorClassForCode(elementCode)]">
        <span class="name print-white">{{ frElementNameForCode(elementCode) }}</span>
        <VizFourBarRating class="large"
          :rating="elementRatingForCode(elementCode)"
          :no-rating-text="noRatingTextForElementCode(elementCode)"
          no-rating-text-class="print-white"
        />
        <VizFourBarRating class="small"
          :rating="elementRatingForCode(elementCode)"
          :no-rating-text="noRatingTextForElementCode(elementCode)"
          no-rating-text-class="print-white"
        />
      </DivPrintableBackground>
      <div class="hover-border"></div>
    </a>
    <FrameworkRatingFootnote :footnote-type="FR_FOOTNOTE_TYPES.SUPPRESS_SE_OR_SA"/>
    <FrameworkRatingFootnote :footnote-type="FR_FOOTNOTE_TYPES.OPT_OUT"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_CURRENT_REPORT } from './const'
import { frElementNameForCode, colorClassForCode } from '@/utils/data'

import DivPrintableBackground from '@/components/DivPrintableBackground'
import VizFourBarRating from '@/components/VizFourBarRating'
import FrameworkRatingFootnote, { FR_FOOTNOTE_TYPES } from './FrameworkRatingFootnote'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolType',
      'elementRatingForCode',
      'noRatingTextForCode',
      'selectedSchoolElementCodes'
    ])
  },
  methods: {
    frElementNameForCode,
    colorClassForCode
  },
  components: {
    DivPrintableBackground,
    VizFourBarRating,
    FrameworkRatingFootnote
  }
})
export default class FrameworkRatings extends Vue {
  loading = true // true on startup
  FR_FOOTNOTE_TYPES = FR_FOOTNOTE_TYPES

  /* Lifecycle */

  mounted () {
    this.loading = false
  }

  /* Methods - utility */
  noRatingTextForElementCode (c) {
    return this.noRatingTextForCode(c, 'see below')
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'src/styles/const.scss';
@import './css/const.scss';
.framework-ratings {
  width: 100%;
  font-size: 16px;
}
.click-wrapper {
  position: relative;
  display: block;
  margin-bottom: 4px;
}
.click-wrapper:hover {
  .rating-row {
    &.color-sa {
      background-color: $fr-darkblue-tint;
    }
    &.color-ri,
    &.color-ct,
    &.color-se, {
      background-color: $fr-orange-tint;
    }
    &.color-es,
    &.color-sf, {
      background-color: $fr-lightblue-tint;
    }
    &.color-tr {
      background-color: $fr-green-tint;
    }
  }
  .hover-border {
    border-style: solid;
    border-color: black;
    opacity: 0.1;
  }
}
.hover-border {
  position: absolute;
  top: 0px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  border-width: 2px;
  border-radius: 4px; /* slightly smaller than rating-row one to overlap */
}
.rating-row {
  height: 34px;
  border-radius: 5px;
  .name {
    float: left;
    margin-left: 18px;
    margin-top: 2px;
    color: white;
    font-weight: bold;
  }
  .viz-four-bar-rating {
    float: right;
    margin-right: 18px;
    /deep/ .no-rating-text {
      color: white;
    }
    &.small /deep/ .no-rating-text {
      font-size: 12px;
    }
  }
}

/* Responsive rules */

.framework-ratings.calculating-layout {
  .viz-four-bar-rating.small {
    visibility: hidden;
  }
}
.framework-ratings:not(.calculating-layout) {
  .viz-four-bar-rating.small {
    display: none;
  }
}

@media screen and (max-width: $screen-width-2-column-small) {
.framework-ratings .rating-row {
  .name {
    font-size: 15px;
  }
}
}
@media screen and (max-width: $medium-screen-width) {
.framework-ratings .rating-row {
  .name {
    margin-left: 14px;
  }
  .viz-four-bar-rating {
    margin-right: 14px;
    &.small {
      display: inline-block;
    }
  }
}
.framework-ratings.calculating-layout {
  .viz-four-bar-rating.large {
    visibility: hidden;
  }
}
.framework-ratings:not(.calculating-layout) {
  .viz-four-bar-rating.large {
    display: none;
  }
}
}
@media screen and (max-width: 704px) {
.framework-ratings .rating-row {
  .name {
    margin-left: 4px;
  }
  .viz-four-bar-rating {
    margin-right: 4px;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {
.framework-ratings .rating-row {
  .name {
    margin-left: 18px;
  }
  .viz-four-bar-rating {
    margin-right: 18px;
    &.large {
      display: inline-block;
    }
  }
}
.framework-ratings.calculating-layout {
  .viz-four-bar-rating.small {
    visibility: hidden;
  }
}
.framework-ratings:not(.calculating-layout) {
  .viz-four-bar-rating.small {
    display: none;
  }
}
}
@media screen and (max-width: $screen-width-1-column-small) {
.framework-ratings .rating-row {
  .name {
    margin-left: 8px;
    font-size: 16px;
  }
  .viz-four-bar-rating {
    margin-right: 8px;
    &.small {
      display: inline-block;
    }
  }
}
.framework-ratings.calculating-layout {
  .viz-four-bar-rating.large {
    visibility: hidden;
  }
}
.framework-ratings:not(.calculating-layout) {
  .viz-four-bar-rating.large {
    display: none;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/FrameworkRatings.vue